import React from 'react';
import { motion } from 'framer-motion';
import '../styles/FeaturesSection.css';

const features = [
  {
    title: '圖鑑系統',
    description: '階級制圖鑑系統，適合不同程度的肝帝！從新手到頂尖玩家，都能找到成就感',
    color: '#45b7d1',
    imageId: 'collection-system'
  },
  {
    title: '職業系統',
    description: '多元職業系統，每種職業多達九種技能，讓你任意配搭！打造專屬於你的戰鬥風格',
    color: '#412899',
    imageId: 'class'
  },
  {
    title: '精緻界面',
    description: '精緻技能界面，再也不怕忘記冷卻時間及技能按鍵！一目了然，戰鬥操作更流暢',
    color: '#6c5ce7',
    imageId: 'skill'
  },
  {
    title: '全新任務系統',
    description: '完善任務系統，全新的 RPG 任務體驗，探索豐富多彩的劇情',
    color: '#00b894',
    imageId: 'quest-system'
  },
  {
    title: '收藏品系統',
    description: '收藏品系統，適合完美主義者遊玩！收藏控的天堂，成就解鎖不停歇',
    color: '#167c16ff',
    imageId: 'collectibles'
  },
  {
    title: '生活系統',
    description: '改良生活系統，各種生活等你體驗！融合附魔系統，任意自由搭配',
    color: '#5c419bff',
    imageId: 'profession'
  },
  {
    title: '專屬插件開發',
    description: '專屬插件擴充，現有插件加以改良！為玩家貼身打造，製作更完美的系統',
    color: '#e17055',
    imageId: 'special-plugins'
  },
  {
    title: '稱號系統',
    description: '獲得各種稱號，提升角色能力和遊戲體驗',
    color: '#f9ca24',
    imageId: 'prefix'
  },
  {
    title: '排行榜競賽',
    description: '挑戰各種排行榜，展現你的實力',
    color: '#fd79a8',
    imageId: 'leaderboard'
  }
];

const FeaturesSection: React.FC = () => {
  return (
    <section className="features" id="features">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">遊戲特色</h2>
          <p className="section-subtitle">
            豐富的遊戲機制與系統，打造最佳的RPG體驗
          </p>
        </motion.div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ 
                y: -10,
                transition: { duration: 0.2 }
              }}
            >
              {/* Feature Image Placeholder */}
              <div className="feature-image-container">
                <img 
                  src={`/images/features/${feature.imageId}.png`}
                  alt={`${feature.title} 功能截圖`}
                  className="feature-image"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    target.nextElementSibling?.classList.remove('hidden');
                  }}
                />
                <div className="feature-placeholder hidden">
                </div>
              </div>
              
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
              
              <div 
                className="feature-glow" 
                style={{ background: `linear-gradient(135deg, transparent 0%, ${feature.color}10 50%, transparent 100%)` }}
              ></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
